export default {
  SET_PLAN_PROP: 'SET_PLAN_PROP',
  SET_GOAL_PROP: 'SET_GOAL_PROP',
  CREATE_GOAL: 'CREATE_GOAL',
  DELETE_GOAL: 'DELETE_GOAL',
  DELETE_ALL_GOALS: 'DELETE_ALL_GOALS',
  ADD_CASHFLOW: 'ADD_CASHFLOW',
  SET_ACTIVE_GOAL: 'SET_ACTIVE_GOAL',
  SET_GLOBAL_SETTING: 'SET_GLOBAL_SETTING',
  LOAD_PROFILE: 'LOAD_PROFILE',
  LOAD_GOALS: 'LOAD_GOALS',
  LOAD_GLOBAL_SETTINGS: 'LOAD_GLOBAL_SETTINGS',
  LOAD_SHARED_PLAN: 'LOAD_SHARED_PLAN',
  SET_SHARE_ID: 'SET_SHARE_ID',
  TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU',
}



// WEBPACK FOOTER //
// ./src/store/actionTypes.js